fragment LookupAccountFields on LookupAccount {
  __typename
  id
  lookupAccount
  lookupName
  setAccount
  isTravelAccountForAllDepartments
  travelAccountTypeId
  departmentGroupId
  corporateLookupAccountId
  corporateAccount {
    id
    lookupAccount
    lookupName
  }

  departmentGroup {
    name
  }
  travelAccountType {
    accountType
  }

  _isDeletable
  _isUpdatable
  _rowTimestamp
}
